import { createTheme } from '@mui/material';

export const serverStatusEnum = {
  CONNECTING: {
    name: 'CONNECTING',
    status: 'connecting',
    message: 'conectando',
    color: createTheme().palette.info.light,
  },
  CONNECTED: {
    name: 'CONNECTED',
    status: 'connected',
    message: 'conectado',
    color: createTheme().palette.success.main,
  },
  DISCONNECTED: {
    name: 'DISCONNECTED',
    status: 'disconnected',
    message: 'desconectado',
    color: createTheme().palette.error.light,
  },
  RECONNECTING: {
    name: 'RECONNECTING',
    status: 'reconnecting',
    message: 'reconectando...',
    color: createTheme().palette.warning.main,
  },
  ERROR: {
    name: 'ERROR',
    status: 'error',
    message: 'server não funcionando',
    color: createTheme().palette.error.main,
  },
};
